import store from '../store';

const ConstTerms = {
  PERSONAL_INFO: 'personal_info',

  MASKING: 'masking',
  MASKING_CHK: 'masking_chk',

  SERVICE_AGREEMENT: 'service_agreement',
  PERSONAL_INFO_AGREE: 'personal_info_agree',
  MARKETING: 'marketing',
  AD_RECEIVE_AGREE: 'ad_receive_agree',

  AD_RECEIVE_EMAIL: 'ad_receive_email',
  AD_RECEIVE_SMS: 'ad_receive_sms',
  AD_RECEIVE_APP: 'ad_receive_app',
  
  INSURANCE_SERVEY: 'insurance_survey',

  INSURANCE: 'insurance',
  INSURANCE_PERSONAL_INFO_AGREE: 'insurance_personal_info_agree',
  INSURANCE_MARKETING: 'insurance_marketing',
  
  PAY_PERSONAL: 'pay_personal',
  PAY_ELECTRONIC_FIN: 'pay_electronic_fin',
  PAY_PERSONAL_INFO: 'pay_personal_info',
  PAY_THIRD_PARTY_PROVIDE: 'pay_third_party_provide',

  ESCALATION: 'escalation',

  getTermsTitle: () => {
    return {
      [ConstTerms.PERSONAL_INFO]:'개인정보처리방침',

      [ConstTerms.SERVICE_AGREEMENT]:'ServiceCare+ 이용 약관',
      [ConstTerms.PERSONAL_INFO_AGREE]:'개인정보 수집 및 이용 동의',
      [ConstTerms.MARKETING]:'마케팅 활용 동의',
      [ConstTerms.AD_RECEIVE_AGREE]:'광고성 정보 수신 동의',

      [ConstTerms.AD_RECEIVE_EMAIL]:'이메일',
      [ConstTerms.AD_RECEIVE_SMS]:'SMS/MMS',
      [ConstTerms.AD_RECEIVE_APP]:'앱푸시',

      [ConstTerms.INSURANCE]:`${store.state.insuranceName} 특별 약관`,
      [ConstTerms.INSURANCE_PERSONAL_INFO_AGREE]:'개인정보 제공 동의',
      [ConstTerms.INSURANCE_MARKETING]:'마케팅 활용 동의',

      [ConstTerms.PAY_PERSONAL]:'주문할 멤버십의 서비스명, 가격정보를 확인하였으며, 구매에 동의하십니까? (전자상거래 제8조 제2항)',
      // [ConstTerms.PAY_ELECTRONIC_FIN]:'전자금융거래 이용약관 동의',
      // [ConstTerms.PAY_PERSONAL_INFO]:'개인정보 수집 및 이용 동의',
      // [ConstTerms.PAY_THIRD_PARTY_PROVIDE]:'개인정보 3자 제공 및 위탁 동의',

      [ConstTerms.ESCALATION]:'양도 시 주의사항 동의',
    }
  }
}

export default ConstTerms;